export default __webpack_public_path__ + "static/media/tumorChannel7.a3f52eb3.png";